'use client'

import { TreeItem } from '@graftcode/design-system'

import { PACKAGE_MANAGER_ICON } from '@/core/const/packageManagerIcon.const'
import { LibraryData } from '@/core/types/library.type'

import { formatLibraryLabel } from '../libraries/formatLibraryLabel'

import { formatHostedRuntimeTooltip } from './formatHostedRuntimeTooltip'
import { mapClassToTreeItem } from './mapClassToTreeItem'

/**
 * Maps LibraryData to a TreeItem for the sidebar: module icon at library level, no icon on classes.
 */
export const mapLibraryToTreeItem = (item: LibraryData): TreeItem => {
  const children: TreeItem[] = []

  if (item.classes) {
    // Use entries to preserve keys (which may include index suffix for uniqueness)
    children.push(...Object.entries(item.classes).map(([key, child]) => mapClassToTreeItem(child, item.id, key)))
  }

  return {
    id: item.id,
    label: formatLibraryLabel(item),
    icon: PACKAGE_MANAGER_ICON,
    tooltip: formatHostedRuntimeTooltip(item.runtimeName, item.runtimeVersion),
    children: children.length > 0 ? children : undefined,
  }
}
